import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import DramaCard from '@/pages/home/components/DramaCard';
import { dramas, categories } from '@/mocks/dramas';

export default function Home() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const featuredDramas = dramas.filter((d) => d.isFeatured);
  const hotDramas = dramas.filter((d) => d.isHot);
  const newDramas = dramas.filter((d) => d.isNew);
  const topRated = [...dramas].sort((a, b) => b.rating - a.rating).slice(0, 8);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/guochan?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '桃子影院-电视剧全集在线观看国产剧韩剧美剧电视剧大全',
              description: '桃子影院电视剧全集在线观看，国产剧韩剧美剧全部免费，不缓冲秒开高清超清蓝光4K画质，永久免费看。',
              url: 'https://www.taozitv.com/',
              isPartOf: { '@type': 'WebSite', name: '桃子影院', url: 'https://www.taozitv.com/' },
            }),
          }}
        />

        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20and%20crimson%20ambient%20lighting%2C%20empty%20velvet%20seats%2C%20large%20screen%20with%20abstract%20glow%2C%20luxurious%20atmosphere%2C%20dramatic%20shadows%2C%20premium%20cinema%20aesthetic&width=1600&height=700&seq=hero-bg-2026&orientation=landscape"
            alt="桃子影院"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-50 mb-4">
              桃子影院 — 电视剧全集在线观看
            </h1>
            <p className="text-foreground-300 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
              国产剧·韩剧·美剧·日剧·动漫·综艺，全网热门电视剧大全，高清超清蓝光4K画质，永久免费，无需缓冲，秒开观看
            </p>
            <form onSubmit={handleSearch} className="flex items-center max-w-xl mx-auto gap-0">
              <div className="relative flex-1">
                <div className="w-5 h-5 flex items-center justify-center absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500">
                  <i className="ri-search-line"></i>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索你想看的电视剧..."
                  className="w-full pl-11 pr-4 py-3.5 bg-background-50/70 backdrop-blur-sm border border-background-300/40 rounded-l-full text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/60 focus:ring-2 focus:ring-primary-500/20 transition-all"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-r-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                搜索
              </button>
            </form>
            <div className="flex items-center justify-center gap-4 mt-6 flex-wrap">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="px-4 py-1.5 rounded-full bg-background-50/30 backdrop-blur-sm border border-foreground-200/20 text-foreground-300 text-xs hover:bg-primary-500/20 hover:border-primary-500/40 hover:text-primary-300 transition-all cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Category Quick Nav */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-500/10 border border-background-200/40 hover:border-primary-500/30 transition-all group cursor-pointer"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-lg md:text-xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-400 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured / Hot Recommendations */}
        {featuredDramas.length > 0 && (
          <section id="hot" className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
            <div className="max-w-[1400px] mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
                    热播推荐
                  </h2>
                  <p className="text-foreground-600 text-xs md:text-sm mt-1">大家都在看的精彩剧集</p>
                </div>
                <Link
                  to="/category/guochan"
                  className="text-primary-400 hover:text-primary-300 text-sm transition-colors flex items-center gap-1 whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
                {featuredDramas.map((drama) => (
                  <DramaCard key={drama.id} drama={drama} />
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Latest Updates */}
        <section id="new" className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100/50">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
                  最新更新
                </h2>
                <p className="text-foreground-600 text-xs md:text-sm mt-1">刚刚上线的热门新剧</p>
              </div>
              <Link
                to="/category/hanju"
                className="text-primary-400 hover:text-primary-300 text-sm transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {newDramas.map((drama) => (
                <DramaCard key={drama.id} drama={drama} />
              ))}
            </div>
          </div>
        </section>

        {/* Top Rated */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
                  高分必看
                </h2>
                <p className="text-foreground-600 text-xs md:text-sm mt-1">口碑爆棚的经典佳作</p>
              </div>
              <Link
                to="/category/meiju"
                className="text-primary-400 hover:text-primary-300 text-sm transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {topRated.map((drama) => (
                <DramaCard key={drama.id} drama={drama} />
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100/50">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center">
              {[
                { value: '10万+', label: '影视资源' },
                { value: '5000万+', label: '活跃用户' },
                { value: '4K蓝光', label: '最高画质' },
                { value: '24h', label: '每日更新' },
              ].map((stat, idx) => (
                <div key={idx}>
                  <div className="text-2xl md:text-3xl font-heading text-primary-400 mb-2">{stat.value}</div>
                  <div className="text-foreground-500 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Advantages */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-3">
                为什么选择桃子影院？
              </h2>
              <p className="text-foreground-600 text-sm max-w-xl mx-auto">
                桃子影院致力于为您提供最优质的在线观影体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  icon: 'ri-4k-line',
                  title: '4K超清画质',
                  desc: '支持4K蓝光超清画质，极致视觉享受，让每一帧都清晰可见。',
                },
                {
                  icon: 'ri-flashlight-line',
                  title: '秒开不缓冲',
                  desc: '全球CDN加速节点覆盖，视频加载速度飞快，告别缓冲等待。',
                },
                {
                  icon: 'ri-shield-star-line',
                  title: '永久免费',
                  desc: '无需会员，无需付费，所有剧集全部免费观看，真正做到永久免费。',
                },
                {
                  icon: 'ri-smartphone-line',
                  title: '多端同步',
                  desc: '手机、平板、电脑多端无缝切换，随时随地追剧不停歇。',
                },
                {
                  icon: 'ri-refresh-line',
                  title: '每日更新',
                  desc: '热门剧集每日同步更新，让您第一时间看到最新剧情。',
                },
                {
                  icon: 'ri-file-list-3-line',
                  title: '海量片库',
                  desc: '收录国产剧、韩剧、美剧、日剧、动漫、综艺等超10万部影视资源。',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/40 hover:border-primary-500/20 transition-all"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 mb-4">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-foreground-200 font-heading text-base mb-2">{item.title}</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20">
          <div className="max-w-[700px] mx-auto text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100 mb-3">
              订阅更新通知
            </h2>
            <p className="text-foreground-600 text-sm mb-6 max-w-md mx-auto">
              第一时间获取最新电视剧更新通知，精彩内容不再错过
            </p>
            <form
              data-readdy-form
              id="newsletter-form"
              action="https://readdy.ai/api/form/d9nhaj8bdkpk99j7gji0"
              method="POST"
              className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            >
              <div className="w-full sm:flex-1">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入您的邮箱地址"
                  className="w-full px-5 py-3 rounded-full bg-background-100 border border-background-300/50 text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 focus:ring-2 focus:ring-primary-500/20 transition-all"
                />
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button
                type="submit"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}